export const SET_LIST_CREDIT_CARD = "SET_LIST_CREDIT_CARD";
export const SET_LIST_CREDIT_CARD_TOTAL_INVOICE = "SET_LIST_CREDIT_CARD_TOTAL_INVOICE";